// removed by extract-text-webpack-plugin
module.exports = {"paginator":"styles__paginator___3qtt1","paginatorBreakLabel":"styles__paginatorBreakLabel___3Gui5","paginatorDisabledItem":"styles__paginatorDisabledItem___3_Kb-","paginatorActiveItem":"styles__paginatorActiveItem___3QLoD","rotate":"styles__rotate___DrS2b","fadein":"styles__fadein___1CLQH","slideFromRight":"styles__slideFromRight___enL9K","waves":"styles__waves___3i_va"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/Results/styles.scss
// module id = ./resources/assets/js/components/Results/styles.scss
// module chunks = 0